export default function useMethods(
    salon: Model.Response<Jury.Resources.Salon>
): Jury.Models.Salon.Methods {
    const hasAwardAbilityIn = getHasAwardAbilityInMethod(salon)

    return {
        hasAwardAbilityIn
    }
}

function getHasAwardAbilityInMethod(salon: Model.Response<Jury.Resources.Salon>) {
    return (sectionId: number) => Boolean(
        salon.data?.responsibility.find(item => item.id === sectionId)?.award_ability
    )
}